// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "img[data-v-6067bd3e]{display:block}.loader[data-v-6067bd3e]{max-width:24px!important}", ""]);
// Exports
module.exports = exports;
